// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"vendors-node_modules_atlas_ui_build_styles_css":"81990e4123f6c55eab89","src_modules_share-css_js":"2a1d128b19623dd076ec"}[chunkId] + "/index.css";
};